import React, { useState, useEffect } from 'react';
import { Trophy, Crown, Star, Medal } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RARITY_STYLES = {
  common: { bg: 'bg-gray-50', border: 'border-gray-200', text: 'text-gray-500', icon: Medal },
  rare: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-600', icon: Star },
  epic: { bg: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-600', icon: Trophy },
  legendary: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-600', icon: Crown },
};

const VaultLeaderboard = () => {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
    fetch(`${API_URL}/api/engagement/leaderboard?limit=10`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => setLeaders(data.leaderboard || []))
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-8 text-sm text-gray-400">Loading leaderboard...</div>;
  if (leaders.length === 0) return <div className="text-center py-8 text-sm text-gray-400">No collectors yet. Be the first!</div>;

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-testid="vault-leaderboard">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center gap-2">
        <Trophy size={18} className="text-amber-500" />
        <h3 className="font-bold text-gray-900">Top Collectors</h3>
      </div>
      <div className="divide-y divide-gray-50">
        {leaders.map((l, i) => {
          const rank = i + 1;
          const rankColors = rank === 1 ? 'text-amber-500 font-black' : rank === 2 ? 'text-gray-400 font-bold' : rank === 3 ? 'text-orange-400 font-bold' : 'text-gray-300 font-medium';
          return (
            <div key={l.user_id} className="px-5 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors" data-testid={`leaderboard-rank-${rank}`}>
              <span className={`w-7 text-center text-sm ${rankColors}`}>#{rank}</span>
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center text-xs font-bold text-purple-600">
                {l.display_name?.charAt(0) || '?'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-900 truncate">{l.display_name}</p>
                <p className="text-xs text-gray-400">{l.total_collectibles} collectibles</p>
              </div>
              <div className="flex items-center gap-1.5">
                {l.legendary > 0 && <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-amber-100 text-amber-600">{l.legendary}L</span>}
                {l.epic > 0 && <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-100 text-purple-600">{l.epic}E</span>}
                {l.rare > 0 && <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-100 text-blue-600">{l.rare}R</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VaultLeaderboard;
